













































import { Notification } from '@/models';
import { getNotificationsAudioMixin } from '@/shared';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import NotificationItem from './NotificationItem.vue';
import NotificationModal from './NotificationModal.vue';

export default mixins(getNotificationsAudioMixin('fanfare-gcoins')).extend({
  name: 'AwardsNotifications',
  components: {
    NotificationItem,
    NotificationModal,
  },
  props: {
    notifications: Array as () => Notification[],
  },
  mounted() {
    if (!this.hasNotifications) {
      this.$emit('complete');
    } else {
      this.playAudio();
    }
  },
  computed: {
    hasNotifications(): boolean {
      return this.grantedGCoinsNotifications.length > 0 ||
        this.acceptedWithdrawalRequestNotifications.length > 0 ||
        this.acceptedCustomAwardNotifications.length > 0;
    },
    grantedGCoinsNotifications(): Notification[] {
      return this.notifications.filter((n) => n.type === 'GrantedGCoinsNotification');
    },
    acceptedWithdrawalRequestNotifications(): Notification[] {
      return this.notifications.filter((n) => n.type === 'AcceptedWithdrawalRequestNotification');
    },
    acceptedCustomAwardNotifications(): Notification[] {
      return this.notifications.filter((n) => n.type === 'AcceptedCustomAwardRequestNotification');
    },
  },
  methods: {
    dismiss() {
      const notificationsToDismiss = this.grantedGCoinsNotifications
        .concat(this.acceptedWithdrawalRequestNotifications, this.acceptedCustomAwardNotifications);
      this.$emit('dismiss', notificationsToDismiss);
      this.stopAudio();
      this.$emit('complete');
    },
  },
});
